import { SelectBaseProps } from 'govwell-ui/components/Select/types'

import { GisSetupEntityLayerFragment } from '../../../../types/graphql'
import { SelectFieldProps } from '../../../utils/forms'
import EntityLayerSelect from '../../Selects/EntityLayerSelect'

type Props<TKey extends string> = Omit<
  SelectBaseProps<GisSetupEntityLayerFragment>,
  'getOptionKey' | 'options'
> &
  SelectFieldProps<GisSetupEntityLayerFragment, TKey>

const EntityLayerSelectField = <TKey extends string>({
  field,
  filterOption,
  isDisabled,
  isMultiSelect,
  isRequired,
  label,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  const commonProps = {
    errorMessage,
    filterOption,
    isDisabled,
    isInvalid: !!errorMessage,
    isRequired: isRequired,
    onBlur: field.handleBlur,
    label: label,
  }

  if (isMultiSelect) {
    return (
      <EntityLayerSelect
        isMultiSelect
        onValueChange={field.setValue}
        value={field.state.value}
        {...commonProps}
      />
    )
  }
  return (
    <EntityLayerSelect
      isMultiSelect={false}
      onValueChange={field.setValue}
      value={field.state.value}
      {...commonProps}
    />
  )
}

export default EntityLayerSelectField
